export function toggleActiveButton(
  clickedButton: HTMLElement,
  groupSelector: string,
  activeColor: string,
  inactiveColor: string,
  activeTextColor: string = "#ffffff",
  inactiveTextColor: string = "#c0c5ca",
  onToggleCallback?: (activeType: string) => void
): void {
  const buttons = document.querySelectorAll<HTMLElement>(groupSelector);

  buttons.forEach((btn) => {
    btn.style.backgroundColor = inactiveColor;
    btn.style.color = inactiveTextColor;
  });

  clickedButton.style.backgroundColor = activeColor;
  clickedButton.style.color = activeTextColor;

  if (onToggleCallback) {
    const activeType = clickedButton.innerText.trim().toLowerCase();
    onToggleCallback(activeType);
  }
}
